module.exports = __webpack_public_path__ + "static/img/6en.f1f3712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/6en.png
// module id = P06K
// module chunks = 0